import React from "react";
import Container from "../ui/Container";
import Button from "../ui/Button";
import { BRAND } from "../../lib/config";
import { Rocket, Users } from "lucide-react";

export default function GameHostingCTA() {
  return (
    <section className="bg-[#070A0F] pb-24 pt-10">
      <Container>
        <div className="mx-auto max-w-4xl text-center">
          <div className="text-xs font-semibold tracking-wider text-white/50">READY</div>
          <h3 className="mt-3 text-balance text-4xl font-semibold leading-[0.95] tracking-tight text-white sm:text-5xl lg:text-6xl">
            Deploy your server today<span className="text-cyan-300">.</span>
          </h3>
          <p className="mx-auto mt-5 max-w-2xl text-white/70 sm:text-lg">
            Start small, scale instantly, and keep performance predictable with transparent pricing.
          </p>

          <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Button href={BRAND.deployUrl} className="w-full sm:w-auto">
              Deploy a Server <Rocket className="h-4 w-4 opacity-80" />
            </Button>
            <Button variant="secondary" href={BRAND.discordUrl} className="w-full sm:w-auto">
              Ask in Discord <Users className="h-4 w-4 opacity-70" />
            </Button>
          </div>
        </div>
      </Container>
    </section>
  );
}
